import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@sandtech-hub-monorepo/ui-kit';

export interface NotFoundProps {
  homeRoute: string;
}

export const NotFound = (props: NotFoundProps) => {
  const navigate = useNavigate();
  return (
    <div className="h-screen mx-auto w-1/2 flex flex-col gap-4 items-center justify-center bg-background">
      <h1 className="text-[7rem] font-bold leading-tight bg-gradient-to-r from-gradient-start to-gradient-stop bg-clip-text text-transparent">
        404
      </h1>
      <span className="font-semibold text-xl sm:text-2xl lg:text-4xl  w-max bg-gradient-to-r from-gradient-start to-gradient-stop bg-clip-text text-transparent">
        Oops! Page Not Found!
      </span>
      <span className="text-sm sm:text-base text-muted-foreground text-center">
        It seems like what you're looking for <br />
        does not exist or might have been removed.
      </span>
      <div className="mt-6 flex gap-4">
        <Button variant="outline" onClick={() => navigate(-1)}>
          Go Back
        </Button>
        <Button
          onClick={() => {
            navigate(props.homeRoute);
          }}
        >
          Back to home
        </Button>
      </div>
    </div>
  );
};
